function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "loans-icon");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#6a80a2",
  width: 45.41,
  height: 40.22,
  rx: 4.58
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#fff",
  points: "37.78 17.6 22.7 7.01 22.7 7.01 22.7 7.01 7.63 17.6 8.74 19.17 22.7 9.37 36.67 19.17 37.78 17.6"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#fff",
  points: "30.34 11.24 33.78 13.72 33.78 7.01 30.34 7.01 30.34 11.24"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.71,11.24,10.84,19.72V33.21H34.57V19.72Zm.74,18.07V31H21.83V29.43A6.76,6.76,0,0,1,19,28.72l.5-1.94a5.83,5.83,0,0,0,2.75.73c.94,0,1.59-.37,1.59-1s-.53-1-1.76-1.44c-1.77-.59-3-1.42-3-3a3.06,3.06,0,0,1,2.8-3V17.49h1.62V19a6.13,6.13,0,0,1,2.41.54l-.49,1.87a5.51,5.51,0,0,0-2.38-.56c-1.08,0-1.42.47-1.42.93s.57.89,2,1.42c2,.7,2.77,1.61,2.77,3.1A3.17,3.17,0,0,1,23.45,29.31Z"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.41,
    height: 40.22,
    viewBox: "0 0 45.41 40.22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/loans-icon.46df840c.svg";
export { SvgComponent as ReactComponent };